import { render, staticRenderFns } from "./TemplateBuilder.vue?vue&type=template&id=50a5125e&scoped=true"
import script from "./TemplateBuilder.vue?vue&type=script&lang=js"
export * from "./TemplateBuilder.vue?vue&type=script&lang=js"
import style0 from "./TemplateBuilder.vue?vue&type=style&index=0&id=50a5125e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50a5125e",
  null
  
)

export default component.exports